import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";


import {FiAirplay, FiDollarSign, FiFileText, FiHelpCircle, FiMail, FiRotateCcw, FiShield, FiStar, FiUser} from "react-icons/fi";
import "./style.css";
import { RiContactsLine, RiFileHistoryLine } from "react-icons/ri";
import { useEffect, useState } from "react";

const sideBarNavlinks = [
  { title: 'Dashboard', link: '/dashboard', icon: <FiAirplay size={16} /> },
  { title: 'Order', link: '/orders', icon: <RiFileHistoryLine size={16} /> },
  { title: 'User Management', link: '/user-management', icon: <FiUser size={16} /> },
  { title: 'Pricing Management', link: '/pricing', icon: <FiDollarSign size={16} />  },
  { title: 'Subscription Management', link: '/subscription-management', icon: <FiDollarSign size={16} /> },
  { title: 'Refunds', link: '/refunds', icon: <FiRotateCcw size={16} /> },
  { title: 'Review Management', link: '/reviews', icon: <FiStar size={16} /> },
  { title: 'PDF Mail Sender', link: '/pdf-mail-sender', icon: <FiMail size={16} /> },
  // { title: 'CMS Management', link: '/cms', icon: <FiFileText size={16} /> },
    {
    title: "CMS Management",
    icon: <FiFileText size={16} />,
    children: [
      { 
        title: "FAQ", 
        link: "/faq", 
        icon: <FiHelpCircle size={14} /> 
      },
      { 
        title: "Terms & Conditions", 
        link: "/terms", 
        icon: <FiFileText size={14} /> 
      },
      { 
        title: "Child Safety Standards",
        link: "/child-safety",
        icon: <FiShield size={14} /> 
      },
      { 
        title: "Contact Queries", 
        link: "/contact-queries", 
        icon: <RiContactsLine size={14} /> 
      },
      { 
        title: "Privacy Policy", 
        link: "/privacy-policy", 
        icon: <FiShield size={14} /> 
      },
    ],
  },
  // { title: 'Create Notification', link: '/create-notification', icon: VolunteersManagement },
  // { title: 'CMS Stats', link: '/stats', icon: EventManagement },
  // { title: 'Programs Management', link: '/programs-management', icon: ProgramsManagement },
  // { title: 'Event Management', link: '/event-management', icon: EventManagement },
  // { title: 'Podcast Management', link: '/podcast-management', icon: PodcastManagement },
  // { title: 'Sponsor Program', link: '/sponsor-program', icon: SponsorshipManagement },
  // { title: 'Top Volunteer Management', link: '/top-volunteer-management', icon: VolunteersManagement },
  // { title: 'Announcement Management', link: '/announcement-management', icon: AnnouncementManagement },
  // { title: 'Sponsorship Management', link: '/sponsorship-management', icon: SponsorshipManagement },
  // { title: 'Our Works Management', link: '/project-management', icon: Dashbord },
  // { title: 'Brand Management', link: '/brand-management', icon: BrandManagement },
  // { title: 'Member Management', link: '/member-management', icon: MemberManagement }
];

/* ===============================
   SIDEBAR
================================= */
export const Sidebar = (props) => {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);

  /* Auto open CMS if child active */
  useEffect(() => {
    const activeParent = sideBarNavlinks.find((item) =>
      item.children?.some((child) =>
        location.pathname.includes(child.link)
      )
    );

    if (activeParent) {
      setOpenMenu(activeParent.title);
    }
  }, [location.pathname]);

  const toggleMenu = (title) => {
    setOpenMenu(openMenu === title ? null : title);
  };

  return (
    <div className={`sidebar ${props.sideClass}`} id="sidebar">
      <ul className="list-unstyled">

        {sideBarNavlinks.map((item) => {
          const isParentActive =
            item.children &&
            item.children.some((child) =>
              location.pathname.includes(child.link)
            );

          return (
            <li className="sidebar-li" key={item.title}>

              {/* ===== CMS WITH CHILD ===== */}
              {item.children ? (
                <>
                  <div
                    className={`sideLink ${
                      openMenu === item.title || isParentActive
                        ? "active"
                        : ""
                    }`}
                    onClick={() => toggleMenu(item.title)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="sideIcon">{item.icon}</span>
                    <span className="sideLinkText">{item.title}</span>
                  </div>

                  {openMenu === item.title && (
                    <ul className="subMenu">
                      {item.children.map((child) => (
                        <li key={child.link}>
                          <Link
                            to={child.link}
                            className={`subLink ${
                              location.pathname === child.link
                                ? "active"
                                : ""
                            }`}
                          >
                            <span className="subIcon">
                              {child.icon}
                            </span>
                            <span>{child.title}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                /* ===== NORMAL LINK ===== */
                <Link
                  className={`sideLink ${
                    location.pathname.includes(item.link)
                      ? "active"
                      : ""
                  }`}
                  to={item.link}
                >
                  <span className="sideIcon">{item.icon}</span>
                  <span className="sideLinkText">{item.title}</span>
                </Link>
              )}

            </li>
          );
        })}

      </ul>
    </div>
  );
};